/**
 * Daten für den Einsatzbericht (Erfassung): Werte, Anzeige-Texte und Farben.
 * Die Schlüssel stehen so in der Datenbank (einsaetze.ergebnis usw.); hier nur Texte für die Oberfläche.
 */
export const SCHLEIFEN = [
  { key: 'DROHNENSTAFFEL', label: 'Drohnenstaffel' },
  { key: 'DROHNENSTAFFEL_FACHBERATER', label: 'Drohnenstaffel-Fachberater' },
] as const

export const ERGEBNISSE = [
  { key: 'GEFUNDEN', label: 'Gefunden' },
  { key: 'UNTERSTUETZUNG_ERFOLGREICH', label: 'Unterstützung erfolgreich' },
  { key: 'OHNE_ERGEBNIS', label: 'Ohne Ergebnis' },
  { key: 'ABGEBROCHEN', label: 'Abgebrochen' },
  { key: 'FEHLALARM', label: 'Fehlalarm' },
] as const

export const ERGEBNIS_PERSONEN = [
  { key: 'LEBEND', label: 'Person lebend' },
  { key: 'VERSTORBEN', label: 'Person verstorben' },
  { key: 'KEINE', label: 'Keine Person' },
] as const

/** Einordnung eines Hotspots durch die Führung; ohne Wert = „nicht eingeordnet“ */
export const HOTSPOT_EINORDNUNGEN = [
  { key: 'RELEVANT', label: 'Relevant', farbe: '#dc2626' },
  { key: 'HINWEIS', label: 'Hinweis', farbe: '#2563eb' },
  { key: 'WILDTIER', label: 'Wildtier', farbe: '#16a34a' },
  { key: 'FEHLALARM', label: 'Fehlalarm', farbe: '#6b7280' },
] as const
/** Kennzeichnung eines eingeordneten Hotspots, der nach einer Neuberechnung des Fotos nicht mehr entsteht */
export const HOTSPOT_NICHT_MEHR_ERKANNT = 'Bei Neuberechnung nicht mehr erkannt'
export const hotspotEinordnungLabel = (k?: string | null) => HOTSPOT_EINORDNUNGEN.find(x => x.key === k)?.label ?? 'Nicht eingeordnet'
export const hotspotEinordnungFarbe = (k?: string | null) => HOTSPOT_EINORDNUNGEN.find(x => x.key === k)?.farbe ?? null

export interface EinsatzBerichtWerte {
  einsatznummer: string
  alarmierende_stelle: string
  einsatzstichwort: string
  alarmierte_schleifen: string[]
  ergebnis: string
  ergebnis_person: string
  ergebnis_text: string
}

export const BERICHT_LEER: EinsatzBerichtWerte = {
  einsatznummer: '', alarmierende_stelle: '', einsatzstichwort: '', alarmierte_schleifen: [], ergebnis: '', ergebnis_person: '', ergebnis_text: '',
}

/** Werte aus einem Einsatz der API (fehlende Felder bei alten Einsätzen -> leer) */
export function berichtWerteAus(e?: Record<string, any> | null): EinsatzBerichtWerte {
  return {
    einsatznummer: e?.einsatznummer ?? '',
    alarmierende_stelle: e?.alarmierende_stelle ?? '',
    einsatzstichwort: e?.einsatzstichwort ?? '',
    alarmierte_schleifen: Array.isArray(e?.alarmierte_schleifen) ? e!.alarmierte_schleifen : [],
    ergebnis: e?.ergebnis ?? '',
    ergebnis_person: e?.ergebnis_person ?? '',
    ergebnis_text: e?.ergebnis_text ?? '',
  }
}

/** Nutzlast fürs Speichern (leer = null, damit auch das Leeren gespeichert wird) */
export function berichtNutzlast(w: EinsatzBerichtWerte) {
  return {
    einsatznummer: w.einsatznummer.trim() || null,
    alarmierende_stelle: w.alarmierende_stelle.trim() || null,
    einsatzstichwort: w.einsatzstichwort.trim() || null,
    alarmierte_schleifen: w.alarmierte_schleifen,
    ergebnis: w.ergebnis || null,
    ergebnis_person: w.ergebnis === 'GEFUNDEN' ? (w.ergebnis_person || null) : null,
    ergebnis_text: w.ergebnis_text.trim() || null,
  }
}

export const schleifenText = (l?: string[] | null) =>
  (l ?? []).map(k => SCHLEIFEN.find(s => s.key === k)?.label ?? k).join(', ')

/** „Gefunden – Person lebend“ bzw. „—“ */
export function ergebnisText(e?: { ergebnis?: string | null; ergebnis_person?: string | null } | null): string {
  const erg = ERGEBNISSE.find(x => x.key === e?.ergebnis)?.label
  if (!erg) return ''
  const person = e?.ergebnis === 'GEFUNDEN' ? ERGEBNIS_PERSONEN.find(x => x.key === e?.ergebnis_person)?.label : null
  return person ? `${erg} – ${person}` : erg
}

/** Beenden/Abschließen: Status oder Phase BEENDET bzw. ABGESCHLOSSEN */
export const istBeendetOderAbgeschlossen = (status?: string | null) => ['BEENDET', 'ABGESCHLOSSEN'].includes(String(status ?? '').toUpperCase())
